export default "__VITE_ASSET__0f914588__"